import { render } from "./RestrictionMeasureTable.vue?vue&type=template&id=a346ca64&scoped=true"
import script from "./RestrictionMeasureTable.vue?vue&type=script&lang=js"
export * from "./RestrictionMeasureTable.vue?vue&type=script&lang=js"

import "./RestrictionMeasureTable.vue?vue&type=style&index=0&id=a346ca64&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a346ca64"]])

export default __exports__